export default "__VITE_ASSET__Dlp1_zcK__"